(ns dashboard.i18n.en
  (:require
   [clojure.string :refer [capitalize]]
   [inflections.core :refer [pluralize plural]]))

(def en
  {:yes "yes"
   :no "no"
   :none "None"
   :time/hours "Hours"
   :time/day "Day"
   :time/date "Date"
   :time/weekends "Weekends"
   :time/weekdays "Weekdays"
   :time/today "Today"
   :time/tomorrow "Tomorrow"
   :time/yesterday "Yesterday"
   :time/week "Week"
   :time/next-week "Next Week"
   :time/previous-week "Previous Week"
   :time/month "Month"
   :time/next-month "Next Month"
   :time/previous-month "Previous Month"
   :time/year "Year"
   :time/day-of-week "Day of the Week"
   :time/day-of-month "Day of the Month"

   :action/actions "Actions"
   :action/sign-in "Sign in"
   :action/sign-out "Sign out"
   :action/save "Save"
   :action/add "Add"
   :action/add-fn (fn [object]
                    (str "Add " object))
   :action/assign "Assign"
   :action/assign-fn (fn [object]
                    (str "Assign " object))
   :action/change "Change"
   :action/create "Create"
   :action/edit "Edit"
   :action/edit-fn (fn [object]
                     (str "Edit " object))
   :action/sync "Sync"
   :action/update "Update"
   :action/download "Download"
   :action/filter "Filter"
   :action/upload "Upload"
   :action/previous "Previous"
   :action/next "Next"
   :action/close "Close"
   :action/select "Select"
   :action/view "View"
   :action/cancel "Cancel"
   :action/uncancel "Un-Cancel"
   :action/view-fn (fn [object]
                     (str "View " object))
   :action/details-fn (fn [object]
                        (str object " Details"))
   :action/upcoming-fn (fn [object]
                         (str "Upcoming " object))
   :action/join "Join"
   :action/decline "Decline"
   :action/delete "Delete"
   :action/delete-all "Delete All"
   :action/delete-fn (fn [object]
                       (str "Delete " object))
   :action/confrim "Confirm"
   :action/confirm-fn (fn [object]
                        (str "Confirm " object))
   :action/export "Export"
   :action/export-fn (fn [object]
                       (str "Export " object))
   :action/import "Import"
   :action/import-fn (fn [object]
                       (str "Import " object))
   :action/message "Message"
   :action/search "Search"
   :action/complete "Complete"

   :non-ideal/page-under-construction "Page Under Construction"
   :non-ideal/page-not-found "Page Not Found"
   :non-ideal/no-entries-to-show "No entries to show"
   :non-ideal/no-data "No data"
   :non-ideal/not-applicable "Not Applicable"
   :non-ideal/no-data-on-this-period "No data available on this period"
   :non-ideal/no-data-on-this-granularity "No data available on this granularity"
   :non-ideal/error-page-title "Unexpected Error"
   :non-ideal/error-page-description "An unexpected error occured."

   :calendar "Calendar"
   :calendar/name "Name"
   :calendar/nameJp "Name (Jp)"
   :calendar/status "Status"
   :calendar/tag "Tag"
   :calendar/tags "Tags"
   :calendar/color "Color"
   :calendar/agenda-view "Agenda View"
   :calendar/month-view "Month View"
   :calendar/week-view "Week View"
   :calendar/day-view "Day View"

   :calendar.tag/id "Tag ID"
   :calendar.tag/name "Name"
   :calendar.tag/nameJp "Name (JP)"
   :calendar.tag/color "Color"
   :calendar.status/id "Status ID"
   :calendar.status/name "Name"
   :calendar.status/nameJp "Name (JP)"
   :calendar.status/color "Color"

   :route.title/loading "Loading"
   :route.title/login "Login"
   :route.title/demo "Demo"
   :route.title/home "Home"
   :route.title/reports "Reports"
   :route.title/calendars "Calendars"
   :route.title/shifts "Boutique Shifts"
   :route.title/settings "Settings"
   :route.title/profile "Profile"
   :route.title/account "Account"
   :route.title/password "Password"
   :route.title/notifications "Notifications"
   :route.title/organization "Organization"
   :route.title/spaces "Spaces"
   :route.title/users "Users"
   :route.title/employees "Employees"
   :route.title/billing "Billing"
   :route.title/teams "Teams"
   :route.title/roles "Roles"
   :route.title/rooms "Rooms"
   :route.title/bookings "Bookings"
   :route.title/events "Events"

   :notifications "Notifications"
   :settings "Settings"
   :settings-fn (fn [object]
                  (str object " Settings"))
   :tags "Tags"
   :user-guide "User Guide"

   :home/upcoming-shifts "Upcoming Shifts"
   :home/my-shifts-colleagues "My Shifts Colleagues"
   :filter/all-spaces "All Boutiques"
   :filter/all-titles "All Titles"
   :filter/all-calendars "All Calendars"
   :filter/all-status "All Status"
   :filter/all-tags "All Tags"

   :user "User"
   :users "Users"
   :staff "Staff"
   :staffs "Staffs"
   :directory "Directory"
   :staff-number "Staff Number"
   :user/name "Name"
   :user/external-id "Staff ID"
   :user/title "Title"
   :user/space "Boutique"
   :user/role "Role"
   :user/team "Team"
   :user/reportTo "Report to"
   :user/isTemporary "OMS"
   :user/locale "Locale"
   :user/spokenLanguages "Spoken Languages"
   :user/email "Email Adress"
   :user/password "Password"
   :user/shiftPreferences "Shift Preferences"

   :role/permissions "Permissions"

   :space "Boutique"
   :space/name "Name"
   :space/nameJp "Name (JP)"
   :space/boutiqueId "Boutique ID"
   :space/active "Active"

   :team "Team"
   :team/color "Color"
   :team/name "Team Name"
   :team/members "Members"

   :schedule "Schedule"
   :event "Event"
   :events "Events"
   :company-events "Company Events"
   :boutique-events "Boutique Events"
   :event/title "Title"
   :event/calendar "Calendar"
   :event/isAllDay "All day"
   :event/start "Start"
   :event/end "End"
   :event/location "Location"
   :event/url "URL"
   :event/status "Status"
   :event/organizer "Organizer"
   :event/attendees "Attendees"
   :event/participants "Participants"
   :event/no-attendees "No attendees"
   :event/tags "Tags"
   :event/description "Description"
   :event.status/pending "Pending"
   :event.status/declined "Declined"
   :event.status/accepted "Accepted"
   :event.status/switched "Switched"

   :shift "Shift"
   :shifts "Shifts"
   :shift/pattern "Shift Pattern"
   :shift/patterns "Shift Patterns"
   :shift/tag "Shift Tag"
   :shift/tags "Shift Tags"
   :shift/comment "Comment"
   :shift/total-hours "Total Hours"
   :shift/hours-difference "Hours Difference"
   :shift/weekends-weekdays-ratio "Weekends / Weekdays"
   :shift/work-days "Work Days"
   :shift/available-sales-staffs "Avaiable Sales Staff"
   :shift/total-staffs "Total Staffs"
   :shift/counts "Counts"

   :shift/formula "Shift Formula"
   :shift.formula/symbol "Symbol"
   :shift.formula/color "Color"
   :shift.formula/patterns "Shift Patterns"
   :shift.formula/teams "Teams"
   :shift.formula/users "Users"
   :shift.formula/filters "Filters"

   :shift-pattern/symbol "Symbol"
   :shift-pattern/startTime "Start"
   :shift-pattern/endTime "End"
   :shift-pattern/hours "Hours"
   :shift-pattern/description "Description"
   :shift-pattern/isDayOff "Is Day Off?"
   :shift-tag/color "Color"
   :shift-tag/symbol "Symbol"
   :shift-tag/description "Description"

   :event/name "Event Name"
   :event/nameJp "Event Name (Jp)"
   :event/floorplan-url "Floorplan URL"

   :room "Room"
   :rooms "Rooms"
   :room/name "Room Name"
   :room/nameJp "Room Name (Jp)"
   :room/color "Color"
   :room/status "Status"
   :room/type "Type"
   :room/coordinates "Coordinates"
   :room/description "Description"

   :room.status/free "Free"
   :room.status/occupied "Occupied"
   :room.status/to-be-cleaned "Cleaned"
   :room.status/cleaned "Cleaned"

   :room.status/assigned "Assigned"

   :booking "Booking"
   :booking/inviter "Inviter"
   :booking/guest "Guest"
   :booking/guestFirstName "Guest First Name"
   :booking/guestLastName "Guest Last Name"
   :booking/guestFirstNameJp "Guest First Name (Jp)"
   :booking/guestLastNameJp "Guest Last Name (Jp)"
   :booking/productName "Product Name"
   :booking/accompanyingGuests "Accompanying Guests"
   :booking/boutiqueName "BTQ Name"
   :booking/inviterName "BTQ Sales"
   :booking/guestId "Guest ID"
   :booking/guestNumbers "Guest Number"
   :booking/roomType "Room Type"
   :booking/guest1Name "Guest 1 Name"
   :booking/guest1NameJp "Guest 1 Name (Jp)"
   :booking/guest1Age "Guest 1 Age"
   :booking/guest2Name "Guest 2 Name"
   :booking/guest2NameJp "Guest 2 Name (Jp)"
   :booking/guest2Age "Guest 2 Age"
   :booking/comment "Comment"
   :booking/start "Start"
   :booking/end "End"
   :booking/date "Date"
   :booking/time "Time"
   :booking/no-accompanying-guests-information "No accompanying guests information"
   :booking/no-room-assigned "No room assigned"
   :booking/not-checked-in "Not checked In"
   :booking/status "Status"
   :booking/cancelled "Cancelled"
   :booking.status/arrived "Check In"
   :booking.status/enter "Assigned" ;; 入室
   :booking.status/exit "Exit"
   :booking.status/cleaned "Cleaned"
   :booking.status/left "Check Out"
   :booking.status/arrived-time "Check In Time"
   :booking.status/enter-time "Assigned Time" ;; 入室
   :booking.status/exit-time "Exit Time"
   :booking.status/cleaned-time "Cleaned Time"
   :booking.status/left-time "Check Out Time"

   :attendance "Attendance"})
